import "animate.css/source/_vars.css";
import "animate.css/source/_base.css";
import "animate.css/source/bouncing_entrances/bounceIn.css";
import "animate.css/source/flippers/flipOutY.css";
const TIMEOUT_MS = 3500;
const SHORT_TIMEOUT_MS = 1000;
let timeout;
let timeoutExpired = false;
let preventAutoHiding = false;
let observer;
let element;
export default function initHerdInstinct(el) {
    if (!el) {
        return;
    }
    element = el;
    if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    hideOnTimeout();
                }
            }
        });
        observer.observe(document.querySelector('.prod-cover__bottom'));
    }
    element.querySelector('.prod-msg__btn').addEventListener('click', hide);
    element.addEventListener('mouseenter', () => preventAutoHiding = true);
    element.addEventListener('mouseleave', () => {
        preventAutoHiding = false;
        hideOnTimeout();
    });
}
function resetTimeout() {
    if (timeout) {
        clearTimeout(timeout);
        timeout = undefined;
    }
}
function hide() {
    resetTimeout();
    element.style.animationName = '';
    element.classList.add('flipOutY', 'animated', 'faster');
    element.addEventListener('animationend', () => {
        if (element.parentElement) {
            element.parentElement.remove();
        }
        observer.disconnect();
    });
}
function hideOnTimeout() {
    timeout = setTimeout(function () {
        timeoutExpired = true;
        if (!preventAutoHiding) {
            hide();
        }
    }, timeoutExpired ? SHORT_TIMEOUT_MS : TIMEOUT_MS);
}
